// import React from "react";
// import { Box, Typography, Grid } from "@mui/material";
// import InternationalTransferFooterButtons from "./InternationalTransferFooterButtons";
// import GreyCircleIcon from "../../../../images/grey-circle.svg";
// import GreenCircleIcon from "../../../../images/green-circle.svg";
// import GreenCircleEmptyIcon from "../../../../images/green-circle-empty.svg";
// import GreyRectVerticalIcon from "../../../../images/grey-rect-vertical.svg";
// import GreenRectVerticalIcon from "../../../../images/green-rect-vertical.svg";

// function InternationalTransferTrack({transactionStatus, handleReturn, isCancellable, handleCancel,handleAmend, intlTransfer, cancelledBy,}) {

//     console.log("InternationalTransferTrack========", transactionStatus);
//     console.log("intlTransfer========", intlTransfer);

//     const statusObj = {
//         ERROR: {
//             header: "Error",
//             dot1: GreyCircleIcon,
//             dot2: GreyCircleIcon,
//             dot3: GreyCircleIcon,
//             line1: GreyRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "Cash",
//             subtext: "",
//             text2: "Recipient",
//         },
//         UNCOMMITTED: {
//             header: "Not Found",
//             dot1: GreyCircleIcon,
//             dot2: GreyCircleIcon,
//             dot3: GreyCircleIcon,
//             line1: GreyRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "Cash",
//             subtext: "Waiting to be processed",
//             text2: "Recipient",
//         },
//         PRCSS: {
//             header: "In Progress",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleEmptyIcon,
//             dot3: GreenCircleEmptyIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "Cash",
//             subtext: "",
//             text2: "Recipient",
//         },
//         HOLD: {
//             header: "In Progress",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleEmptyIcon,
//             dot3: GreenCircleEmptyIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "Cash",
//             subtext: "This transaction is currently on hold.",
//             text2: "Recipient",
//         },
//         AVAIL: {
//             header: "In Progress",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleEmptyIcon,
//             dot3: GreyCircleIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "",
//             subtext: "Ready - Transfer is waiting for pickup",
//             text2: "Recipient",
//         },
//         CANCL: {
//     header: "Cancelled",
//     dot1: GreyCircleIcon,
//     dot2: GreyCircleIcon,
//     dot3: GreyCircleIcon,
//     line1: GreyRectVerticalIcon,
//     line2: GreyRectVerticalIcon,
//     text1: "Cash",
//     subtext: cancelledBy || "",
//     text2: "Recipient",
// },
//         RECVD: {
//             header: "Received",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleIcon,
//             dot3: GreenCircleIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreenRectVerticalIcon,
//             text1: "Cash",
//             subtext: "",
//             text2: "Recipient",
//         },
//         REFND: {
//             header: "Refunded",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleEmptyIcon,
//             dot3: GreenCircleIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "Cash",
//             subtext: "",
//             text2: "Refunded",
//         },
//         ApprovalPending: {
//             header: "Approval Pending",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleEmptyIcon,
//             dot3: GreenCircleEmptyIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "Cash",
//             subtext: "",
//             text2: "Recipient",
//         },
//         AFR: {
//             header: "In Progress",
//             dot1: GreenCircleIcon,
//             dot2: GreenCircleEmptyIcon,
//             dot3: GreyCircleIcon,
//             line1: GreenRectVerticalIcon,
//             line2: GreyRectVerticalIcon,
//             text1: "",
//             subtext: intlTransfer == "Moneygram" ? "Available For Refund - Contact Moneygram" : "Available For Refund",
//             text2: "Recipient",
//         }
//     };


//     return (
//         <Box sx={{
//             maxHeight: "600px",
//             marginTop: "10px"
//         }}>
//             <Box
//                 sx={{
//                     maxWidth: 400,
//                     margin: "100px auto",
//                 }}
//             >
//                 <Typography
//                     id="status-modal"
//                     sx={{ color: "green", fontWeight: "bold",  }}
//                 >
//                     {statusObj[transactionStatus]?.header}
//                 </Typography>

//                 <Grid container alignItems="center" spacing={2} >
//                     <Grid item>
//                         <img src={statusObj[transactionStatus]?.dot1} alt="Dot 1" style={{ height: "28px", width: "28px" }} loading="lazy"/>
//                     </Grid>
//                 </Grid>

//                 <Box sx={{ position: "relative", left: "3%" }}>
//                     <img src={statusObj[transactionStatus]?.line1} alt="Line 1" loading="lazy" style={{ top: "10%" }}/>
//                 </Box>

//                 <Grid container alignItems="center" spacing={1} sx={{ padding: "0px" }}>
//                     <Grid item>
//                         <img src={statusObj[transactionStatus]?.dot2} alt="Dot 2" loading="lazy"  style={{ height: "28px", width: "28px" }}/>
//                     </Grid>
//                     <Grid item>
//                         <Box>
//                             <Typography
//                                 sx={{ color: "green", fontWeight: "bold",  }}
//                             >
//                                 {statusObj[transactionStatus]?.text1}
//                             </Typography>
//                             {statusObj[transactionStatus]?.subtext && (
//                                 <Typography
//                                     variant="body2"
//                                     sx={{ color: "green", fontWeight: "bold" }}
//                                 >
//                                     {statusObj[transactionStatus]?.subtext}
//                                 </Typography>
//                             )}
//                         </Box>
//                     </Grid>
//                 </Grid>

//                 <Box sx={{ position: "relative", left: "3%" }}>
//                     <img src={statusObj[transactionStatus]?.line2} alt="Line 2" style={{ position: "relative", }} loading="lazy"/>
//                 </Box>

//                 <Grid container alignItems="center" spacing={2} sx={{ position: "relative", bottom: "8px" }}>
//                     <Grid item>
//                         <img src={statusObj[transactionStatus]?.dot3} alt="Dot 3" style={{ height: "28px", width: "28px" }} loading="lazy" />
//                     </Grid>
//                     <Grid item>
//                         <Typography sx={{ color: "green", fontWeight: "bold" }}>
//                             {statusObj[transactionStatus]?.text2}
//                         </Typography>
//                     </Grid>
//                 </Grid>
//             </Box>
//             <Box className="buttonContainer">
//             <InternationalTransferFooterButtons
//                 handleButtonOne={handleReturn}
//                 buttonOneText="Back"
//                 showButtonOne={true}
//                 showButtonTwo={transactionStatus === "AVAIL"}
//                 buttonTwoText={transactionStatus === "AVAIL" ? "Amend Name" : ""}
//                 handleButtonTwo={handleAmend}
//                 showMiddleButton={isCancellable && transactionStatus === "AVAIL"}
//                 middleButtonText={isCancellable && transactionStatus === "AVAIL" ? "Cancel Transaction" : ""}
//                 handleMiddleButton={handleCancel}
//             />
//             </Box>
//         </Box>
//     )
// }

// export default InternationalTransferTrack;


// // const statusObj = {
// //     ERROR: {
// //         header: "Error",
// //         dot1: GreyCircleIcon,
// //         dot2: GreyCircleIcon,
// //         dot3: GreyCircleIcon,
// //         line1: GreyRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "",
// //         text2: "Recipient",
// //     },
// //     UNCOMMITTED: {
// //         header: "Not Found",
// //         dot1: GreyCircleIcon,
// //         dot2: GreyCircleIcon,
// //         dot3: GreyCircleIcon,
// //         line1: GreyRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "Waiting to be processed",
// //         text2: "Recipient",
// //     },
// //     PRCSS: {
// //         header: "In Progress",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleEmptyIcon,
// //         dot3: GreenCircleEmptyIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "",
// //         text2: "Recipient",
// //     },
// //     HOLD: {
// //         header: "In Progress",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleEmptyIcon,
// //         dot3: GreenCircleEmptyIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "This transaction is currently on hold.",
// //         text2: "Recipient",
// //     },
// //     AVAIL: {
// //         header: "In Progress",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleEmptyIcon,
// //         dot3: GreyCircleIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "",
// //         subtext: "Ready - Transfer is waiting for pickup",
// //         text2: "Recipient",
// //     },
// //     CANCL: {
// //         header: "Cancelled",
// //         dot1: GreyCircleIcon,
// //         dot2: GreyCircleIcon,
// //         dot3: GreyCircleIcon,
// //         line1: GreyRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "",
// //         text2: "Recipient",
// //     },
// //     RECVD: {
// //         header: "Received",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleIcon,
// //         dot3: GreenCircleIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreenRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "",
// //         text2: "Recipient",
// //     },
// //     REFND: {
// //         header: "Refunded",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleEmptyIcon,
// //         dot3: GreenCircleIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "",
// //         text2: "Refunded",
// //     },
// //     ApprovalPending: {
// //         header: "Approval Pending",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleEmptyIcon,
// //         dot3: GreenCircleEmptyIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "Cash",
// //         subtext: "",
// //         text2: "Recipient",
// //     },
// //     AFR: {
// //         header: "In Progress",
// //         dot1: GreenCircleIcon,
// //         dot2: GreenCircleEmptyIcon,
// //         dot3: GreyCircleIcon,
// //         line1: GreenRectVerticalIcon,
// //         line2: GreyRectVerticalIcon,
// //         text1: "",
// //         subtext: intlTransfer == "Moneygram" ? "Available For Refund" : "Available For Refund",
// //         text2: "Recipient",
// //     }
// // };


import React from "react";
import { Box } from "@mui/material";
import InternationalTransferFooterButtons from "./InternationalTransferFooterButtons";

function InternationalTransferTrack({
  transactionStatus,
  handleReturn,
  isCancellable,
  handleCancel,
  handleAmend,
  intlTransfer,
  cancelledBy,
  refundedBy
}) {

  const statusConfig = {
    AVAIL: {
      badge: "Ready for pickup",
      badgeStyle: { background: "#e3f2fd", color: "#1565c0", border: "0.5px solid #90caf9" },
      badgeIcon: "⏳",
      steps: [
        { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
        { label: "Awaiting collection", sub: "Ready — recipient can collect at any MoneyGram location", active: true, isMiddle: true },
        { label: "Recipient collection", sub: "Pending", active: false },
      ],
      infoBox: null,
    },
    HOLD: {
      badge: "On hold",
      badgeStyle: { background: "#fff8e1", color: "#f57f17", border: "0.5px solid #ffe082" },
      badgeIcon: "⚠️",
      steps: [
        { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
        { label: "Under review", sub: "This transfer is currently on hold pending verification.", active: true, isMiddle: true, subColor: "#e65100" },
        { label: "Recipient collection", sub: "Pending clearance", active: false },
      ],
      infoBox: {
        style: { background: "#fff8e1", border: "0.5px solid #ffe082" },
        titleColor: "#e65100",
        title: "Transfer on hold",
        desc: "Contact MoneyGram or NCS support to provide any additional information required to release the funds. Reach us at support@onrevegrand.com or 1-649-946-4227.",
      },
    },
    RECVD: {
      badge: "Received",
      badgeStyle: { background: "#e8f5e9", color: "#1b5e20", border: "0.5px solid #a5d6a7" },
      badgeIcon: "✓",
      steps: [
        { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
        { label: "In transit", sub: "Transfer was processed successfully", active: true, isMiddle: true },
        { label: "Recipient collected", sub: "Funds paid out to recipient", active: true },
      ],
      infoBox: null,
    },
    CANCL: {
      badge: "Cancelled",
      badgeStyle: { background: "#ffebee", color: "#b71c1c", border: "0.5px solid #ef9a9a" },
      badgeIcon: "✕",
      steps: [
        { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
        { label: "Transfer cancelled", sub: "This transfer was cancelled before the recipient could collect.", active: false, isMiddle: true, isCancel: true, subColor: "#c62828" },
        { label: "Recipient collection", sub: "Not reached", active: false, isMuted: true },
      ],
      infoBox: cancelledBy ? {
        style: { background: "#ffebee", border: "0.5px solid #ef9a9a" },
        titleColor: "#b71c1c",
        title: cancelledBy,
        desc: cancelledBy === "Cancelled by Our Agent"
          ? "This transfer was reversed by an NCS agent. If you have questions, contact support at support@onrevegrand.com"
          : "This transfer was cancelled by MoneyGram. Please contact MoneyGram directly or reach NCS support at support@onrevegrand.com.",
      } : null,
    },
    AFR: {
      badge: intlTransfer === "Moneygram" ? "Available for refund" : "In progress",
      badgeStyle: { background: "#fff8e1", color: "#f57f17", border: "0.5px solid #ffe082" },
      badgeIcon: "↺",
      steps: [
        { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
        {
          label: intlTransfer === "Moneygram" ? "Available for refund" : "In transit",
          sub: intlTransfer === "Moneygram" ? "Contact MoneyGram to process the refund." : "Being processed.",
          active: true, isMiddle: true, subColor: "#e65100"
        },
        { label: "Recipient collection", sub: "Pending", active: false },
      ],
      infoBox: null,
    },
    PRCSS: {
      badge: "Processing",
      badgeStyle: { background: "#e3f2fd", color: "#1565c0", border: "0.5px solid #90caf9" },
      badgeIcon: "⟳",
      steps: [
        { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
        { label: "Processing", sub: "Transfer is being processed.", active: true, isMiddle: true },
        { label: "Recipient collection", sub: "Pending", active: false },
      ],
      infoBox: null,
    },
    ERROR: {
      badge: "Error",
      badgeStyle: { background: "#ffebee", color: "#b71c1c", border: "0.5px solid #ef9a9a" },
      badgeIcon: "!",
      steps: [
        { label: "Transfer initiated", sub: "", active: false },
        { label: "Unknown status", sub: "Could not determine the current status of this transfer.", active: false, isMiddle: true, subColor: "#c62828" },
        { label: "Recipient collection", sub: "", active: false },
      ],
      infoBox: null,
    },
   REFND: {
  badge: "Refunded",
  badgeStyle: { background: "#e8f5e9", color: "#1b5e20", border: "0.5px solid #a5d6a7" },
  badgeIcon: "↩",
  steps: [
    { label: "Transfer initiated", sub: "Funds collected from sender", active: true },
    { label: "Transfer refunded", sub: "This transfer was refunded back to the sender.", active: true, isMiddle: true, subColor: "#1b5e20" },
    { label: "Refunded to sender", sub: "Funds returned to original sender", active: true },
  ],
  infoBox: refundedBy ? {
    style: { background: "#e8f5e9", border: "0.5px solid #a5d6a7" },
    titleColor: "#1b5e20",
    title: refundedBy,
    desc: refundedBy === "Refunded by Our Agent"
      ? "This transfer was refunded by an NCS agent. If you have questions, contact support at support@onrevegrand.com"
      : "This transfer was refunded by MoneyGram. Please contact MoneyGram directly or reach NCS support at support@onrevegrand.com.",
  } : null,
},
  };

  const config = statusConfig[transactionStatus] || statusConfig.ERROR;

  const getDotStyle = (step) => {
    if (step.isCancel) return { background: "#ffebee", border: "2px solid #ef9a9a", color: "#c62828" };
    if (step.active)   return { background: "#e8f5e9", border: "2px solid #a5d6a7", color: "#2e7d32" };
    return { background: "#f5f5f5", border: "2px solid #e0e0e0", color: "#9e9e9e" };
  };

  const getLineColor = (step) => step.active ? "#a5d6a7" : "#e0e0e0";

  return (
    <Box sx={{ maxHeight: "600px", marginTop: "10px", overflowY: "auto" }}>

      {/* Status card */}
      <Box sx={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "12px",
      }}>

        {/* Header row */}
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          paddingBottom: "14px",
          borderBottom: "1px solid #f0f0f0",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}>
          <Box sx={{ fontSize: "14px", fontWeight: 500, color: "#212121", fontFamily: "'Nunito', sans-serif" }}>
            MoneyGram transfer
          </Box>
          <Box sx={{
            ...config.badgeStyle,
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            padding: "3px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 500,
            fontFamily: "'Nunito', sans-serif",
          }}>
            <span style={{ fontSize: "11px" }}>{config.badgeIcon}</span>
            {config.badge}
          </Box>
        </Box>

        {/* Stepper */}
        {config.steps.map((step, i) => (
          <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
            {/* Dot + line column */}
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "24px", flexShrink: 0 }}>
              <Box sx={{
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                fontSize: "10px",
                fontWeight: 700,
                ...getDotStyle(step),
              }}>
                {step.isCancel ? "✕" : step.active ? "✓" : "○"}
              </Box>
              {i < config.steps.length - 1 && (
                <Box sx={{
                  width: "2px",
                  height: "32px",
                  margin: "2px 0",
                  background: getLineColor(step),
                }} />
              )}
            </Box>

            {/* Step text */}
            <Box sx={{ paddingBottom: i < config.steps.length - 1 ? "0px" : "4px", paddingTop: "1px" }}>
              <Box sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: step.isMuted ? "#9e9e9e" : step.isCancel ? "#c62828" : "#212121",
                fontFamily: "'Nunito', sans-serif",
              }}>
                {step.label}
              </Box>
              {step.sub && (
                <Box sx={{
                  fontSize: "12px",
                  color: step.subColor || "#757575",
                  marginTop: "2px",
                  marginBottom: "16px",
                  fontFamily: "'Nunito', sans-serif",
                  lineHeight: 1.4,
                }}>
                  {step.sub}
                </Box>
              )}
            </Box>
          </Box>
        ))}

        {/* Info / cancelledBy box */}
        {config.infoBox && (
          <Box sx={{
            ...config.infoBox.style,
            borderRadius: "8px",
            padding: "11px 13px",
            marginTop: "12px",
          }}>
            <Box sx={{
              fontSize: "13px",
              fontWeight: 600,
              color: config.infoBox.titleColor,
              fontFamily: "'Nunito', sans-serif",
              marginBottom: "4px",
            }}>
              {config.infoBox.title}
            </Box>
            <Box sx={{
              fontSize: "12px",
              color: "#616161",
              fontFamily: "'Nunito', sans-serif",
              lineHeight: 1.5,
            }}>
              {config.infoBox.desc}
            </Box>
          </Box>
        )}
      </Box>

      {/* Footer buttons */}
      <InternationalTransferFooterButtons
        handleButtonOne={handleReturn}
        buttonOneText="Back"
        showButtonOne={true}
        showButtonTwo={transactionStatus === "AVAIL"}
        buttonTwoText="Amend name"
        handleButtonTwo={handleAmend}
        showMiddleButton={isCancellable && transactionStatus === "AVAIL"}
        middleButtonText="Cancel transfer"
        handleMiddleButton={handleCancel}
      />
    </Box>
  );
}

export default InternationalTransferTrack;